import './App.css'
import React from 'react'
import { Route, Routes } from 'react-router-dom'

import Viewer from './pages/viewer'
import UnitView from './pages/unit'
import Search from './pages/search'
import Home from './pages/Home'
import { darkTheme, lightTheme } from './styles/theme'

import { ThemeProvider } from '@mui/material/styles'
import { useSelector } from 'react-redux'

function App () {
  const mode = useSelector(state => state.viewer.colorMode)

  return (
                <ThemeProvider theme={mode === 'light' ? lightTheme : darkTheme}>
                    <div className="App">
                      <Routes>
                        <Route path="/" element={<Home/>} />
                        <Route path="/search" exact element={<Search/>} />
                        <Route path="/viewer/:id" exact element={<Viewer/>} />
                        <Route path="/viewer/:id/unit/:unitId" exact element={<UnitView/>} />
                      </Routes>
                    </div>
                </ThemeProvider>
  )
}

export default App
